import { DATA_TYPE_NEW_TABLE } from "components/NewTable/interfaces";
import NewTable, { TableHeaderColumn, TableNav, TableBodyData } from "components/NewTable";
import PageDefault from "components/PageDefault";
import { Button, Col, Row } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import flowService from "services/flow.service";
import { useTranslation } from 'react-i18next'
import actionService from "services/action.service";
// import { useUser } from "store/models";
import Can from "components/Can";
import Icon from "components/Icon";
import { createCancelToken } from "utils/http-common";

export default function Actions(props?:any) {
  const history = useHistory();
  
  const [ status, setStatus ] = useState([]);
  const [ statusLoad, setStatusLoad ] = useState(true);
  
  const {t} = useTranslation()
  useEffect(()=>{
    const {token, cancel} = createCancelToken();
    setStatusLoad(true)
    flowService.getStatusWithCount(1,{params:{
    },cancelToken:token}).then((data)=>{
      setStatus(data);
      setStatusLoad(false)
    });

    return ()=>{
      cancel();
    }
  },[]);

  return (
    <PageDefault title={t('action:page_title')}>
      <PageDefault.Title>{t('action:page_title')}</PageDefault.Title>
      <PageDefault.Content>
        <Row className="mt-3 mb-3 justify-content-between align-items-center">
          <Col>
            <Can permission="action.index.create">
              <Link to="/action/create">
                <Button size="sm">{t('action:add_btn')}</Button>
              </Link>
            </Can>
          </Col>
          <Col xs="auto">
            {/* <Row>
              <SelectYear value={year} onChange={setYear}/>
            </Row> */}
          </Col>
        </Row>
        <NewTable>
          <TableNav dataField="action_status_id" items={status} setAll={true} loading={statusLoad}></TableNav>
          <TableHeaderColumn dataField="id">{t("action:table_header:id")}</TableHeaderColumn>
          <TableHeaderColumn dataField="company.name" bodyNowrap>{t("action:table_header:company")}</TableHeaderColumn>
          {/* <TableHeaderColumn dataField="plan.name" bodyNowrap>{t("action:table_header:plan")}</TableHeaderColumn> */}
          <TableHeaderColumn dataField="start_date" type={DATA_TYPE_NEW_TABLE.DATE} headerNowrap>Data de abertura</TableHeaderColumn>
          <TableHeaderColumn dataField="end_date" type={DATA_TYPE_NEW_TABLE.DATE} headerNowrap>Data de Fechamento</TableHeaderColumn>
          <TableHeaderColumn dataField="value" bodyNowrap type={DATA_TYPE_NEW_TABLE.CURRENCY}>{t("action:table_header:value")}</TableHeaderColumn>
          <TableHeaderColumn dataField="id|" isAction mask={(v:any[])=>{
            const [id] = v;
            return (
              <>
                <Can permission="action.index.update">
                  <Button size="sm" style={{margin:"0px 1px"}} onClick={()=>{history.push(`action/edit/${id}`);}}><Icon name="edit"/></Button>
                </Can>
                <Can permission="action.index.view">
                  <Button size="sm" style={{margin:"0px 1px"}} onClick={()=>{history.push(`action/show/${id}`);}}><Icon name="eye"/></Button>
                </Can>
              </>
            )
          }}></TableHeaderColumn>
          <TableBodyData
            request={actionService}
            filterDefaut={{
              embed:"company:id,name"
              +"|"
              +"fund"
            }}
          />
        </NewTable>
      </PageDefault.Content>
    </PageDefault>
  );
}

export { default as ActionForm } from "./ActionForm";